import { FONT_SIZE } from '../TextBox/constants';

export const EMOJI_FONT_SIZE_FACTOR = 16 / FONT_SIZE.DEFAULT;

export const EMOJI_RESOLUTION = 256;
